import { CallMethod } from "csi/xml/CallMethod";
import def from "csi/def";
import FormData from "csi/action/FormData";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import { ViewWidget } from "csi/view/Widget";
import Controller from "csi/action/Controller";
import declare from "dojo/_base/declare";
import xml from "csi/xml";
import { FormWidget } from "csi/form/Widget";

const PromoteStyleBOMToThemeBOM = declare([Controller, ActionControllerMixin], {

	styleBomFd: null,
	themeUrl: null,
	NODE_NAME: "Node Name",
	SUBTYPE: "Subtype",
	THEME: "Theme",
	THEME_MASTER: "ThemeMaster",

	getFormData: function (): FormData {
		const fd = this.styleBomFd = this.inherited<FormData>(arguments);
		fd.setNode(null);
		return fd;
	},


	_insertFields: function (view: FormWidget): void {
		const style = this.getParent();
		this.themeUrl = style.Theme;
		const theme = this.m_cache.getNode(this.themeUrl);
		const themeMasterUrl = theme.__Parent__;
		const themeMaster = this.m_cache.getNode(themeMasterUrl);

		//insert fields
		//theme master
		view.insertFieldIfNotExist(this.THEME_MASTER, 1, {
			m_typeControl: def.FIELD_TEXTAREA,
			m_bRequired: false,
		});
		view.setFieldDisabled(this.THEME_MASTER, true);
		view.addFixedValue(this.THEME_MASTER, themeMaster.$Name);

		//theme
		view.insertFieldIfNotExist(this.THEME, 2, {
			m_typeControl: def.FIELD_TEXTAREA,
			m_bRequired: false,
		});
		view.setFieldDisabled(this.THEME, true);
		view.addFixedValue(this.THEME, theme.$Name);

		//Disable Subtype
		view.setFieldDisabled(this.SUBTYPE, true);
	},

	_onCreatePopup: function (view: ViewWidget): void {
		this._insertFields(view as FormWidget);
		this.inherited(arguments);
	},

	/**
	* @override
	*/
	toWriterRequest: function (): CallMethod {
		const { styleBomFd } = this;
		const themeBOMName = styleBomFd.getFieldValue(this.NODE_NAME);
		const call = this.inherited<CallMethod>(arguments);
		call.addParameter("CNL", xml.ATTR_STRING, this.getNode());
		call.addParameter("ToTheme", xml.ATTR_STRING, this.themeUrl);
		call.addParameter("ThemeBomName", xml.ATTR_STRING, themeBOMName);
		return call;
	},

});
export = PromoteStyleBOMToThemeBOM;